import React from 'react';

const FilterBar = ({ filters, onFilterChange }) => (
  <div className="filter-bar">
    <div className="search-wrap">
      <svg className="search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="text"
        className="search-input"
        placeholder="Search products..."
        name="flavor"
        value={filters.flavor || ''}
        onChange={(e) => onFilterChange('flavor', e.target.value)}
      />
    </div>
    <button
      className={`filter-chip ${filters.active_only ? 'on' : ''}`}
      onClick={() => onFilterChange('active_only', !filters.active_only)}
    >
      Active Only
    </button>
  </div>
);

export default FilterBar;
